import { render, staticRenderFns } from "./LoadingPaymentInfo.vue?vue&type=template&id=0a2a5b81&scoped=true"
import script from "./LoadingPaymentInfo.vue?vue&type=script&lang=js"
export * from "./LoadingPaymentInfo.vue?vue&type=script&lang=js"
import style0 from "./LoadingPaymentInfo.vue?vue&type=style&index=0&id=0a2a5b81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2a5b81",
  null
  
)

export default component.exports